/** @format */
import { commonCodeFilterModule } from './code.filter';
import { codeEditorModule } from './codeEditor.dir';
import { LocalizedMarkupStringComponent } from './localized-markup-string/localized-markup-string.component';
import { localizedMarkupStringEditorModule } from './localizedMarkupStringEditor.dir';
import { localizedStringModule } from './localizedString.dir';
import { localizedStringEditorModule } from './localizedStringEditor.dir';
import { MarkupStringComponent } from './markup-string/markup-string.component';
import { markupStringEditorModule } from './markupStringEditor.dir';
import { sortByLocalizedValueFilterModule } from './sortByLocalizedValue.filter';
import { textareaLengthModule } from './textareaLength.dir';

export const commonStringModule = 'sis-components.string';

(function () {
    angular.module(commonStringModule, [
        codeEditorModule,
        localizedStringModule,
        localizedStringEditorModule,
        localizedMarkupStringEditorModule,
        markupStringEditorModule,
        commonCodeFilterModule,
        sortByLocalizedValueFilterModule,
        textareaLengthModule,
        MarkupStringComponent.downgrade.moduleName,
        LocalizedMarkupStringComponent.downgrade.moduleName,
    ]);
})();
